import * as React from "react";

export const DesqualifyLeadIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M28 18.25a9.547 9.547 0 0 0-4.922 1.336 9.597 9.597 0 0 0-3.492 3.492A9.547 9.547 0 0 0 18.25 28c0 1.766.445 3.406 1.336 4.922a9.597 9.597 0 0 0 3.492 3.492A9.547 9.547 0 0 0 28 37.75a9.547 9.547 0 0 0 4.922-1.336 9.597 9.597 0 0 0 3.492-3.492A9.547 9.547 0 0 0 37.75 28a9.547 9.547 0 0 0-1.336-4.922 9.597 9.597 0 0 0-3.492-3.492A9.547 9.547 0 0 0 28 18.25Zm0 1.5c1.5 0 2.89.375 4.172 1.125a8.356 8.356 0 0 1 2.953 2.953A8.114 8.114 0 0 1 36.25 28c0 1-.172 1.969-.516 2.906a8.408 8.408 0 0 1-1.453 2.438L22.773 21.602a7.829 7.829 0 0 1 2.415-1.36A8.07 8.07 0 0 1 28 19.75Zm-6.281 2.906 11.508 11.742a8.225 8.225 0 0 1-2.414 1.383A8.43 8.43 0 0 1 28 36.25c-1.5 0-2.89-.375-4.172-1.125a8.356 8.356 0 0 1-2.953-2.953A8.114 8.114 0 0 1 19.75 28c0-1 .172-1.969.516-2.906a8.408 8.408 0 0 1 1.453-2.438Z"
      fill="#000"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
